import React, { Component } from 'react'

import { joinClasses } from '~/components/utils/react_helper';

export default class ValidationError extends Component {
  render() {
    if (!this.hasErrors()) {
      return null;
    }

    const className = joinClasses([
      'validation-error',
      this.props.className,
      this.props.version === '2' && 'validation-error--v2',
    ]);

    return (
      <div className={className}>
        {this.props.errors[0]}
      </div>
    );
  }

  hasErrors() {
    return this.props.errors && Object.keys(this.props.errors).length > 0;
  }
}
